//Import
import React from "react";
import styled from "styled-components";
import { ICol, IRow } from "../Grid";
import MainFormButton from "../MainFormButton";
import OfcInput from "../OfcInput";
import styles from "./GroupFormContainer_styles";
import {Tag} from "antd";

// Componente base
const GroupFormContainer_base = ({
                                   totalMora,
                                   totalCobro,
                                   totalGastos,
                                   totalCreditos,
                                   totalSeguro,
                                   totalCierre,
                                   totalEfectivo,
                                   totalBanco,
                                   caja,
                                   totalDevoluciones,
                                   totalSaldados,
                                   cajaInicial,
                                   fechaCajaInicial,
                                   handleAplicarCierre,
                                   handleVerPdfMora,
                                   disabled,
                                   seguro,
                                   ...props
                                 }) => {
  return (
      <div {...props}>
        <IRow w="78" align="center">
          <form action="">
            <ICol>
              <OfcInput
                  value={totalMora + " - Ver PDF"}
                  labelname={"TOTAL MORA: "}
                  labelfor="totalmora"
                  disabled={disabled}
                  type="text"
                  onClick={handleVerPdfMora}
              />
            </ICol>
            <ICol>
              <OfcInput
                  value={cajaInicial}
                  labelname={"Caja Inicial Fecha: " + fechaCajaInicial}
                  labelfor="cajainicial"
                  disabled={disabled}
              />
            </ICol>
            <ICol>
              <OfcInput
                  value={totalCobro}
                  labelname="Total Cobro"
                  labelfor="totalcobro"
                  disabled={disabled}
              />
            </ICol>
              {localStorage.getItem("metodoPago") === "BANCO_EFECTIVO" && (
                  <>
                      <Tag color="blue">
                          BANCO: {totalBanco}
                      </Tag>

                      <Tag color="green">
                          EFECTIVO: {totalEfectivo}
                      </Tag>
                  </>
              )}

            <ICol>
              <OfcInput
                  value={totalGastos}
                  labelname="Total Gastos"
                  labelfor="totalgastos"
                  disabled={disabled}
              />
            </ICol>

            <ICol>
              <OfcInput
                  value={totalCreditos}
                  labelname="Total Créditos Nuevos"
                  labelfor="totalcredito"
                  disabled={disabled}
              />
            </ICol>

            <ICol>
              <OfcInput
                  value={totalDevoluciones}
                  labelname="Total Devoluciones"
                  labelfor="totaldevoluciones"
                  disabled={disabled}
              />
            </ICol>

            <ICol>
              <OfcInput
                  value={totalSaldados}
                  labelname="Total Saldados"
                  labelfor="totalsaldados"
                  disabled={disabled}
              />
            </ICol>
            <ICol>
              <OfcInput
                  value={totalSeguro}
                  labelname="Total Seguro"
                  labelfor="totalseguro"
                  disabled={disabled}
              />
            </ICol>

            <ICol>
              <OfcInput
                  value={totalCierre}
                  labelname="Cierre del día"
                  labelfor="cierredeldia"
                  disabled={disabled}
              />
            </ICol>

            <ICol>
              <OfcInput
                  value={caja}
                  labelname="Caja Final"
                  labelfor="cajafinal"
                  disabled={disabled}
              />
            </ICol>

            <ICol pt="1" pb="3">
              <MainFormButton
                  handleAplicarCierre={handleAplicarCierre}
                  text="Aplicar"
              />
            </ICol>
          </form>
        </IRow>
      </div>
  );
};
const GroupFormContainer = styled(GroupFormContainer_base)`
  ${styles}
`;
export default GroupFormContainer;
